// extracted by mini-css-extract-plugin
module.exports = {"cookieBot":"_3pWBquOVBBgbN0zbPga-L4"};